import React, { useState, useEffect } from 'react';
import api from '../services/api';
import {
  Box, TextField, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, IconButton, Alert, CircularProgress,
  Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';

function TipoEquipamentoManager() {
  const [tipos, setTipos] = useState([]);
  const [tipo, setTipo] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const fetchTipos = () => {
    setLoading(true);
    api.get('/tipos-equipamento')
      .then((response) => setTipos(response.data || []))
      .catch((err) => {
        console.error('Erro ao buscar tipos de equipamento:', err);
        setError('Não foi possível carregar os tipos de equipamento.');
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchTipos();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!tipo.trim() || submitting) return;
    setSubmitting(true);
    setError('');

    const request = editingId
      ? api.put(`/tipos-equipamento/${editingId}`, { tipo: tipo.trim() })
      : api.post('/tipos-equipamento', { tipo: tipo.trim() });

    request
      .then(() => {
        setTipo('');
        setEditingId(null);
        setDialogOpen(false);
        fetchTipos();
      })
      .catch((err) => {
        console.error('Erro ao salvar tipo de equipamento:', err);
        setError(err.response?.data || 'Erro ao salvar tipo de equipamento.');
      })
      .finally(() => setSubmitting(false));
  };

  const handleEdit = (item) => {
    setEditingId(item.id);
    setTipo(item.tipo);
    setDialogOpen(true);
  };

  const handleDelete = (id) => {
    if (!window.confirm('Tem certeza que deseja deletar este tipo de equipamento?')) return;
    api.delete(`/tipos-equipamento/${id}`)
      .then(() => fetchTipos())
      .catch((err) => {
        console.error('Erro ao deletar tipo de equipamento:', err);
        setError(err.response?.data || 'Erro ao deletar tipo de equipamento.');
      });
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setTipo('');
    setDialogOpen(false);
  };

  const handleNew = () => {
    handleCancelEdit();
    setDialogOpen(true);
  };

  return (
    <Box>
      {error && <Alert severity="error" onClose={() => setError('')} sx={{ mb: 2 }}>{error}</Alert>}

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleNew}>
          Novo tipo
        </Button>
      </Box>

      <Dialog open={dialogOpen} onClose={handleCancelEdit} fullWidth maxWidth="sm">
        <Box component="form" onSubmit={handleSubmit}>
          <DialogTitle>{editingId ? 'Editar Tipo de Equipamento' : 'Cadastro de Tipo de Equipamento'}</DialogTitle>
          <DialogContent>
          <TextField
            label="Tipo (descrição)"
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
            fullWidth
            required
            placeholder="Ex.: Computadores, Câmeras, Nobreaks, Ar condicionados"
            margin="dense"
          />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancelEdit} disabled={submitting}>Cancelar</Button>
            <Button type="submit" variant="contained" disabled={submitting}>
              {submitting ? <CircularProgress size={20} color="inherit" /> : 'Salvar'}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Tipo</TableCell>
              <TableCell align="right">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow><TableCell colSpan={2} align="center"><CircularProgress size={24} /></TableCell></TableRow>
            ) : tipos.length === 0 ? (
              <TableRow><TableCell colSpan={2} align="center">Nenhum tipo de equipamento cadastrado.</TableCell></TableRow>
            ) : tipos.map((item) => (
              <TableRow key={item.id}>
                <TableCell>{item.tipo}</TableCell>
                <TableCell align="right">
                  <IconButton size="small" aria-label="editar" onClick={() => handleEdit(item)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton size="small" aria-label="deletar" onClick={() => handleDelete(item.id)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default TipoEquipamentoManager;
